import { render } from "./trade-assistant-en.vue?vue&type=template&id=d5d86368&scoped=true"
import script from "./trade-assistant-en.vue?vue&type=script&lang=js"
export * from "./trade-assistant-en.vue?vue&type=script&lang=js"

import "./trade-assistant-en.vue?vue&type=style&index=0&id=d5d86368&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d86368"]])

export default __exports__